"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Card = function (_a) {
    var title = _a.title, current = _a.current, from = _a.from, percentage = _a.percentage, positive = _a.positive;
    return react_1.default.createElement(storybook_1.Cards.Card, null,
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("dt", { className: 'storybook-graphs-card-title' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, title)),
            react_1.default.createElement("dd", { className: 'storybook-graphs-card-stats' },
                react_1.default.createElement("div", { className: 'storybook-graphs-card-stats-body' }, current))));
};
exports.Card = Card;
exports.Card.propTypes = {
    /**
     * The HTML inside of the Card
     */
    title: prop_types_1.default.string.isRequired,
    /**
     * The current value
     */
    current: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]).isRequired,
    /**
     * The value in the past
     */
    from: prop_types_1.default.number,
    /**
     * The percentage
     */
    percentage: prop_types_1.default.string,
    /**
     * Is de percentage positive?
     */
    positive: prop_types_1.default.bool
};
exports.Card.defaultProps = {
    positive: true
};
